// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2wdbu","disabled":"FileBtn_disabled__3QIUb","warn":"FileBtn_warn__2bIMo","fade":"FileBtn_fade__3xyyH"};